import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		Input
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhachHangService } from '../../../danh-muc/khach-hang/khach-hang-service/khach-hang.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CommonConFig, NhaCungCapModelLite } from '../../../dung-chung/__model/common_config.model';
import { SelectionModel } from '@angular/cdk/collections';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
import { DonHangMuaDataSource } from '../don-hang-mua-page-datasource/don-hang-mua.datasource';
import { DonHangMuaService } from '../don-hang-mua-page-service/don-hang-mua.service';
import { LichSuGiaoHang } from '../don-hang-mua-page-model/don-hang-mua.model';
import { environment } from '../../../../../../../environments/environment';

@Component({
	selector: 'kt-lich-su-gia-mua-hang',
	templateUrl: './lich-su-gia-mua-hang.component.html',
	styleUrls: ['../don-hang-mua-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class LichSuGiaMuaHangComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	dataSource: DonHangMuaDataSource;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading = false;
	/* ------------------------------------------------------------------ */

	//#region Phím tắt
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode){
			this.back();
		}
	}
	//#endregion Phím tắt

	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true,
			type: 'number'
        },
        {
            stt: 2,
            name: 'MaNCC',
            displayName: 'Mã NCC',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
        },
        {
            stt: 3,
            name: 'TenNCC',
            displayName: 'Tên NCC',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
		},
		{
            stt: 4,
            name: 'DVT',
            displayName: 'DVT',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
        },
        {
            stt: 5,
            name: 'SL',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
		},
		{
            stt: 5,
            name: 'SoPhieuDHM',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
		},
		{
            stt: 5,
            name: 'NgayDatHang',
            displayName: 'Ngày đặt hàng',
            alwaysChecked: false,
			isShow: true,
			type: 'date'
		},
		{
            stt: 5,
            name: 'DonGia',
            displayName: 'Đon giá',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
		}
		,{
            stt: 5,
            name: 'LoaiTien',
            displayName: 'Loại tiền',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
		}
	];
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	preFilterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	
	@Input() title: string = "LỊCH SỬ GIÁ MUA HÀNG";
	@Input() subTitle: string = "";
  @Input() estimatedPrice: number = 0;

	DonHangMuaResult = [];
	tmpDonHangMuaResult = [];

	SoLanMua: number = 5;

	Title : string[] = [];
	DataLine : number[] = [0];
	DataBar : number[] = [0];

	IdHH : number = 0;

	Form: FormGroup;

	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<any>(true, []);

	showChart : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	denngay = new Date();
	tungay = new Date();

	maxDate = this.denngay;
	minDate = this.tungay;

  groupedData: any[] = [];
  selectedNCC: BehaviorSubject<string> = new BehaviorSubject<string>("0");

	constructor(
		public 	dialogRef2: MatDialogRef<LichSuGiaMuaHangComponent>,
		public 	dialog2: MatDialog,
		private changeDetect: ChangeDetectorRef,
		private service : DonHangMuaService,
		private layoutUtilsService: LayoutUtilsService,
		public dialogRef: MatDialogRef<LichSuGiaMuaHangComponent>,
		private FormFB : FormBuilder,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
	}

	//#region Load Data
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		this.subTitle = this.data.Ma_Ten_HH;
    this.estimatedPrice = this.data.estimatedPrice;
		this.IdHH = this.data.IdHH;
		this.createForm();
		this.tmpDonHangMuaResult = [];
		this.loadData(true);
		this.applySelectedColumns();
		this.changeDetect.detectChanges();
	}

	async loadData(all: boolean = false){
		//if(Number(this.Form.controls['SOLANMUA'].value) <= 0) return;
		this.showChart.next(false);
		var data = {
			IdHH : this.IdHH,
			//SoLanMua : Number(this.Form.controls['SOLANMUA'].value),
			TuNgay : all? null : moment(this.Form.controls['TUNGAY'].value).format('YYYY-MM-DD[T]00:00:00.000'),
			DenNgay : all? null: moment(this.Form.controls['DENNGAY'].value).format('YYYY-MM-DD[T]23:59:59.999'),
		}
		let res = await this.service.LichSuGiaMuaHang(data).toPromise();
    
		if(res && res.status == 1){
			this.groupedData = [];
			let groupedByKey: any = {};
			res.data.forEach(item => {
				let groupKey = `${item.Id}`;
				if (!groupedByKey[groupKey]) {
					groupedByKey[groupKey] = [];
				}
				const lastItem = groupedByKey[groupKey].length > 0 ? groupedByKey[groupKey][groupedByKey[groupKey].length - 1] : null;
				if (
					lastItem &&
					this.getFormatDate(lastItem.NgayDatHang) === this.getFormatDate(item.NgayDatHang) &&
					+lastItem.DonGia === +item.DonGia &&
					lastItem.LoaiTien === item.LoaiTien &&
					lastItem.DVT === item.DVT
				) {
					lastItem.SoLuong += item.SoLuong;
				} else {
					groupedByKey[groupKey].push({...item});
				}
			});
			for (const key in groupedByKey) {
				if (groupedByKey.hasOwnProperty(key)) {
					this.groupedData.push({
						Id: key,
            MaNCC: groupedByKey[key][0].MaNCC,
            TenNCC: groupedByKey[key][0].TenNCC,
						items: groupedByKey[key].reverse()
					});
				}
			}
      console.log(this.groupedData);

			if(this.tmpDonHangMuaResult.length > 0 && all){
				this.Form.controls['DENNGAY'].setValue(this.tmpDonHangMuaResult[0].NgayDatHang);
				this.Form.controls['TUNGAY'].setValue(this.tmpDonHangMuaResult[this.tmpDonHangMuaResult.length-1].NgayDatHang);
				this.minDate = new Date(this.Form.controls['TUNGAY'].value);
				this.maxDate = new Date(this.Form.controls['DENNGAY'].value);
			}
			this.showChart.next(true);
      this.selectedNCC.next("0");
			this.changeDetect.detectChanges();
		}else{
			this.layoutUtilsService.showErorr("Lỗi lấy danh sách giá mua");
		}
	}

	createForm(){
		this.Form = this.FormFB.group({
			//SOLANMUA : [5, Validators.compose([Validators.required, Validators.min(1)])],
			TUNGAY: [new Date(), Validators.required],
			DENNGAY: [new Date(), Validators.required]
		});
	}

	filterConfiguration(): any {
		const filter: any = {};
		return filter;
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Quay về
	back(){
		this.dialogRef2.close({});
	}
	//#endregion Quay về

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}

	fomartData(data : any, type: string){
		switch(type){
			case 'number': return this.f_number(data);
			case 'string': return data;
			case 'date' : return moment(data).format("DD/MM/YYYY");
			case 'datetime' : return moment(data).format("DD/MM/YYYY HH:mm");
			default: return data;
		}
	}

	setMinDate(){
		this.minDate = new Date(this.Form.controls['TUNGAY'].value.toDate());
		this.changeDetect.detectChanges();
	}

	setMaxDate(){
		this.maxDate = new Date(this.Form.controls['DENNGAY'].value.toDate());
		this.changeDetect.detectChanges();
	}

  onGroupChange(event: any) {
    this.selectedNCC.next(event.value);
  }

  getBarChartLabels(items: any[]): string[] {
    return items.map(x => this.getFormatDate(x.NgayDatHang));
  }

  getDataLineChart(items: any[]): number[] {
    return items.map(x => +x.DonGia);
  }

  getDataBarChart(items: any[]): number[] {
    return items.map(x => +x.SoLuong);
  }

}

